import { ref } from "vue";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useRoute, useRouter } from "vue-router";

export default function () {
  const user = ref(null);
  const auth = getAuth();
  const router = useRouter();
  const route = useRoute();
  const userLoaded = ref(false);
  const userData = ref(null);

  onAuthStateChanged(auth, async (firebaseUser) => {
    userLoaded.value = true;
    if (firebaseUser) {
      user.value = firebaseUser;
    } else if (route.path !== "/") {
      router.push("auth");
    }
  });

  return {
    user,
    userLoaded,
    userData,
  };
}
